import { render, staticRenderFns } from "./HubSystemItem.vue?vue&type=template&id=dd7023da&scoped=true&"
import script from "./HubSystemItem.vue?vue&type=script&lang=js&"
export * from "./HubSystemItem.vue?vue&type=script&lang=js&"
import style0 from "./HubSystemItem.vue?vue&type=style&index=0&id=dd7023da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd7023da",
  null
  
)

export default component.exports